const getScope = (state) => state.modules.common.modals.inviteModal;

export const getIsSendInvitesModalOpen = (state) =>
  getScope(state).isInviteModalOpen;

export const getIsInvitesSentModalOpen = (state) =>
  getScope(state).isInvitesSentModalOpen;

export const getIsInvitesSkippedModalOpen = (state) =>
  getScope(state).isInvitesSkippedModalOpen;

export const getIsFetching = (state) => getScope(state).isFetching;
